module.exports = __webpack_public_path__ + "img/factsheet_laadpaal.0a454c8f.png";